module.exports = __webpack_public_path__ + "img/empty.585531a8.png";